import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './LastActionCard.module.scss'
import Action from './Action'

const LastActionCard = ({ data }) => {
  const { t } = useTranslation('common')
  return (
    <div className={styles.last_action_card_wrapper}>
      <h4>{t('statistic.last_actions')}</h4>
      {data?.map((item) => {
        return <Action item={item} />
      })}
    </div>
  )
}

export default LastActionCard
